import { useCallback, useEffect, useState } from 'react'

// utils
import { 
  getDishContract, 
  getDishMasterAddress, 
  getApprovedERC721,
  getBakerySoccerContract,
  getBakerySoccerMasterAddress,
  getSoccerPokerGameBoxMasterAddress,
  getSoccerPokerGameBoxContract,
  getSoccerPokerGameBoxBurnByProxyMasterAddress
} from '../../sushi/utils'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '..'
import useInterval from '../useInterval'
import { NFTTYPE } from '../../constants/bakery/nft'

const useAllowanceNFT = (
  {
    tokenId,
    requested,
    reset,
    type
  }: {
    tokenId: string,
    requested?: boolean,
    reset?: boolean,
    type?: string
  }
) => {
  const [allowance, setAllowance] = useState(false)
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  let dishContract = getDishContract(sushi)
  let dishMasterAddress = getDishMasterAddress(sushi)

  switch (type) {
    case NFTTYPE.SOCCER:
      dishContract = getBakerySoccerContract(sushi)
      dishMasterAddress = getBakerySoccerMasterAddress(sushi)
      break
    case NFTTYPE.GAMEBOX:
      dishContract = getSoccerPokerGameBoxContract(sushi)
      dishMasterAddress = getSoccerPokerGameBoxMasterAddress(sushi)
      break
    case 'GAMEBOXBURN':
      dishContract = getSoccerPokerGameBoxContract(sushi)
      dishMasterAddress = getSoccerPokerGameBoxBurnByProxyMasterAddress(sushi)
      break
  }

  const fetchAllowance = useCallback(async () => {
    if (account) {
      try {
        const allowance = await getApprovedERC721(dishContract, tokenId)
        // if allowance === dishMasterAddress means approved
        setAllowance(allowance === dishMasterAddress)
      } catch (e) {
        setAllowance(false)
      }
    }
  }, [account, dishContract, tokenId, dishMasterAddress])

  useEffect(() => {
    if (account && dishContract && tokenId) {
      fetchAllowance()
    }
  }, [account, dishContract, tokenId, fetchAllowance])

  useInterval(fetchAllowance, reset || (requested && !allowance) ? 3000 : null)

  return allowance
}

export default useAllowanceNFT
